import { langResources } from "../language/index";

const createShortcut = (shortcutKey, en, tr) => ({
    shortcutKey,
    en,
    tr,
    ru: en,
});

const shortcutAll = [
    createShortcut(
        "CTRL + M",
        langResources.en.message.openPrivateChat.replace("{shortcut}", "CTRL + M"),
        langResources.tr.message.openPrivateChat.replace("{shortcut}", "CTRL + M")
    ),
    createShortcut(
        "CTRL + ↑",
        langResources.en.message.closeActiveChat.replace("{shortcut}", "CTRL + ↑"),
        langResources.tr.message.closeActiveChat.replace("{shortcut}", "CTRL + ↑")
    ),
    createShortcut(
        "CTRL + →",
        langResources.en.message.nextChatFromActive.replace("{shortcut}", "CTRL + →"),
        langResources.tr.message.nextChatFromActive.replace("{shortcut}", "CTRL + →")
    ),
    createShortcut(
        "CTRL + ←",
        langResources.en.message.previousChatFromActive.replace("{shortcut}", "CTRL + ←"),
        langResources.tr.message.previousChatFromActive.replace("{shortcut}", "CTRL + ←")
    ),
    createShortcut(
        "CTRL + ↓",
        langResources.en.message.hideActiveChat.replace("{shortcut}", "CTRL + ↓"),
        langResources.tr.message.hideActiveChat.replace("{shortcut}", "CTRL + ↓")
    ),
    createShortcut(
        "ESC",
        langResources.en.message.escKey.replace("{shortcut}", "ESC"),
        langResources.tr.message.escKey.replace("{shortcut}", "ESC")
    ),
    createShortcut(
        "F1",
        langResources.en.message.focusInput.replace("{shortcut}", "F1"),
        langResources.tr.message.focusInput.replace("{shortcut}", "F1")
    ),
    createShortcut(
        "F2",
        langResources.en.message.firsthiddenChat.replace("{shortcut}", "F2"),
        langResources.tr.message.firsthiddenChat.replace("{shortcut}", "F2")
    ),
    createShortcut(
        "F3",
        langResources.en.message.firstChatWaiting.replace("{shortcut}", "F3"),
        langResources.tr.message.firstChatWaiting.replace("{shortcut}", "F3")
    ),
    createShortcut(
        "F4",
        langResources.en.message.previousOpenedChat.replace("{shortcut}", "F4"),
        langResources.tr.message.previousOpenedChat.replace("{shortcut}", "F4")
    ),
    createShortcut(
        "#hash",
        langResources.en.message.hashHintMessage.replace("{shortcut}", "#hash"),
        langResources.tr.message.hashHintMessage.replace("{shortcut}", "#hash")
    ),
    createShortcut(
        "PM",
        langResources.en.message.pmHintMessage.replace("{shortcut}", "PM"),
        langResources.tr.message.pmHintMessage.replace("{shortcut}", "PM")
    ),
    createShortcut(
        "",
        langResources.en.message.shortcutHintMessage.replace("{shortcut}", ""),
        langResources.tr.message.shortcutHintMessage.replace("{shortcut}", "")
    ),
    createShortcut(
        "`CTRL + ,",
        langResources.en.message.chatCopilot.replace("{shortcut}", "`CTRL + ,"),
        langResources.tr.message.chatCopilot.replace("{shortcut}", "`CTRL + ,")
    ),
    // createShortcut(
    //     "1,2,3",
    //     langResources.en.message.switchBetweenConversations.replace("{shortcut}", "1,2,3"),
    //     langResources.tr.message.switchBetweenConversations.replace("{shortcut}", "1,2,3")
    // ),
    createShortcut(
        "@name",
        langResources.en.message.atNameHintMessage.replace("{shortcut}", "@name"),
        langResources.tr.message.atNameHintMessage.replace("{shortcut}", "@name")
    ),
    createShortcut(
        "",
        langResources.en.message.dndHintMessage.replace("{shortcut}", ""),
        langResources.tr.message.dndHintMessage.replace("{shortcut}", "")
    ),
    createShortcut(
        "CTRL + V",
        langResources.en.message.pasteFile.replace("{shortcut}", "CTRL + V"),
        langResources.tr.message.pasteFile.replace("{shortcut}", "CTRL + V")
    ),
    // createShortcut(
    //     "@email",
    //     langResources.en.message.atEmailHintMessage.replace("{email}", "@email"),
    //     langResources.tr.message.atEmailHintMessage.replace("{email}", "@email")
    // ),
    createShortcut(
        "CTRL + SHIFT + V",
        langResources.en.message.pastePlainText.replace("{shortcut}", "CTRL + SHIFT + V"),
        langResources.tr.message.pastePlainText.replace("{shortcut}", "CTRL + SHIFT + V")
    ),
    createShortcut(
        "CTRL + W",
        "Did you know? You can quickly end a conversation with CTRL + W",
        "Biliyor muydun? Görüşmeyi hızlıca sonlandırmak için CTRL + W tuşlarını kullanabilirsin"
    ),
    createShortcut(
        "CTRL + F",
        "Pro tip: Forward this chat to another agent using CTRL + F",
        "İpucu: Bu chat'i başka bir temsilciye yönlendirmek için CTRL + F tuşlarını kullan"
    ),
    createShortcut(
        "CTRL + P",
        "Need to send a private message? Press CTRL + P for internal notes",
        "Gizli mesaj göndermen mi gerekiyor? Dahili notlar için CTRL + P tuşlarına bas"
    ),
    createShortcut(
        "CTRL + B",
        "Tip: Block unwanted contacts instantly with CTRL + B",
        "İpucu: İstenmeyen kişileri anında engellemek için CTRL + B kullan"
    ),
    createShortcut(
        "CTRL + T",
        "Stay organized! Create tasks directly from chat with CTRL + T",
        "Organize kal! Chat içinden doğrudan görev oluşturmak için CTRL + T kullan"
    ),
    createShortcut(
        "CTRL + O",
        "Want to see contact details? Press CTRL + O to view their profile",
        "Kişi detaylarını görmek ister misin? Profili görüntülemek için CTRL + O tuşlarına bas"
    ),
    createShortcut(
        "C",
        "Quick tip: Mark conversations as answered by simply pressing C",
        "Hızlı ipucu: Görüşmeleri cevaplandı olarak işaretlemek için sadece C tuşuna bas"
    ),
    createShortcut(
        "CTRL + 1",
        "Love the classic view? Switch to Chat Layout anytime with CTRL + 1",
        "Klasik görünümü mü seviyorsun? İstediğin zaman CTRL + 1 ile Chat Layout'a geç"
    ),
    createShortcut(
        "CTRL + 2",
        "Manage multiple chats efficiently! Switch to Table Layout with CTRL + 2",
        "Birden fazla chat'i verimli yönet! CTRL + 2 ile Table Layout'a geç"
    ),
    createShortcut(
        "CTRL + 3",
        "Visualize your workflow! Press CTRL + 3 to switch to Kanban Layout",
        "İş akışını görselleştir! Kanban Layout'a geçmek için CTRL + 3 tuşlarına bas"
    ),
    createShortcut(
        "CTRL + K",
        "Looking for something? Use CTRL + K for instant search across Supsis",
        "Bir şey mi arıyorsun? Supsis'te anında arama yapmak için CTRL + K kullan"
    ),
    createShortcut(
        "TAB",
        "Check system performance at a glance! Press TAB to view system status",
        "Sistem performansını bir bakışta kontrol et! Sistem durumunu görmek için TAB tuşuna bas"
    ),
    // createShortcut(`CTRL + "`, langResources.en.message.pressAndTallk, langResources.tr.message.pressAndTallk),
];

const getRandomShortcut = () => {
    const randomIndex = ~~(Math.random() * shortcutAll.length);
    const defaultShortcut = createShortcut(
        "F1",
        langResources.en.message.focusInput,
        langResources.tr.message.focusInput
    );
    return shortcutAll[randomIndex] || defaultShortcut;
};

export default getRandomShortcut;
